<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<template>
  <div
    class="flex flex-col items-center justify-center gap-2 py-16 text-center border border-dashed rounded-lg border-n-weak"
  >
    <span
      class="flex items-center justify-center w-10 h-10 rounded-full bg-n-slate-3 text-n-slate-11"
    >
      <span class="i-lucide-hammer text-lg" />
    </span>
    <p class="font-medium text-n-slate-12">{{ title }}</p>
    <p class="text-sm text-n-slate-11">{{ $t('META_ADS.COMING_SOON') }}</p>
  </div>
</template>
